import React, { useContext } from 'react'
import styled from 'styled-components'
import Ficha from './ficha'
import { COLOR_TYPES } from '../constantes/colores.ts';
import { BOTONES } from '../constantes/enums.ts';
import { ICON_TYPES } from '../constantes/iconos.ts';
import { ContextoDispositivo } from '../contextos/Dispositivo.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';

const Call = () => {
    const navigate = useNavigate()
    const { dispositivo } = useContext(ContextoDispositivo)
    return (
        <Seccion>
            <Container>
                {dispositivo ? <><Ficha color={COLOR_TYPES.SECUNDARY} navegar='/Equipo' titulo='NUESTROS COLABORADORES' tipo={BOTONES.INFO} icono={ICON_TYPES.TEAM} />
                    <Ficha color={COLOR_TYPES.SECUNDARY} navegar='/servicio-social' titulo='REALIZA TU SERVICIO SOCIAL CON NOSOTROS' tipo={BOTONES.INFO} icono={ICON_TYPES.SERVICIO} />
                    <Ficha color={COLOR_TYPES.SECUNDARY} navegar='/Actividades' titulo='CONOCE NUESTRAS ACTIVIDADES' tipo={BOTONES.INFO} icono={ICON_TYPES.ACTIVIDADES} /></> :
                    <><Caja onClick={() => navigate('/Equipo')} >
                        <h4 style={{ fontWeight: 'normal', fontSize: '12px', textAlign: 'center' }} >NUESTROS COLABORADORES</h4>
                        <Circulo >
                            <Icon icon={ICON_TYPES.TEAM} style={{ fontSize: '36px' }} />
                        </Circulo>
                    </Caja>
                        <Caja onClick={() => navigate('/servicio-social')}>
                            <h4 style={{ fontWeight: 'normal', fontSize: '12px', textAlign: 'center' }} >REALIZA TU SERVICIO SOCIAL CON NOSOTROS</h4>

                            <Circulo >
                                <Icon icon={ICON_TYPES.SERVICIO} style={{ fontSize: '36px' }} />
                            </Circulo>
                        </Caja>
                        <Caja onClick={() => navigate('/Actividades')} >
                            <h4 style={{ fontWeight: 'normal', fontSize: '12px', textAlign: 'center' }} >CONOCE NUESTRAS ACTIVIDADES</h4>
                            <Circulo >
                                <Icon icon={ICON_TYPES.ACTIVIDADES} style={{ fontSize: '36px' }} />
                            </Circulo>
                        </Caja>
                    </>
                }
            </Container>
        </Seccion>
    )
}

const Seccion = styled.section`
    position: relative;

`

const Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    transform: translateY(-30%)
`
const Caja = styled.div`
    padding: 15px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 32.5%;
    height: 130px;
    background-color: var(--secundary);
    border-radius: 20px;
    position: relative;
    cursor: pointer;
`

const Circulo = styled.div`
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: var(--secundary);
    box-shadow: 0 -5px 10px white;
    height: 50px;
    width: 50px;
    position: absolute;
    bottom: 0;
    transform: translateY(50%)
`

export default Call